import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { ResourceLinks } from "../../../../constants";
import './../../../../assets/styles/select-img-part.css';
import { useSelector } from "../../../../store";

export default function WebCalendar({ question, onAnswer = () => {} }) {
    const questionData = question;
    const learnerState = useSelector((state) => state.learner || {});
    const data = learnerState?.details?.testLevel === "vfh" ? questionData?.vfh : questionData?.acsf4;
    const imagesResources = ResourceLinks.llnQuizImage;

    const [boxes, setBoxes] = useState([]);
    const [answer, setAnswer] = useState([]);

    // every time question change we will set to reset needed to reset
    useEffect(() => {
        const processSetBoxes = () => {
            const monthShift = data.month === "January" ? 2 : 0;
    
            const boxData = Array.from(
                { length: data.days },
                (_, index) => {
                    const shiftedIndex = index + monthShift;
                    return {
                        id: `box-${index}`,
                        top: 32.5 + Math.floor(shiftedIndex / 7) * (60 / 450) * 100,
                        left: 0.7 + (shiftedIndex % 7) * (120 / 854) * 100,
                        width: 120,
                        height: 60,
                    };
                }
            );
    
            setBoxes(boxData);
        }
        processSetBoxes();
        setAnswer([]);
    }, [question, data.month, data.days]);

    const handleBoxClick = (index) => {
        setAnswer((prevAnswer) => {
            const item = (index + 1).toString();
            let updatedAnswer;

            if (prevAnswer.includes(item)) {
                updatedAnswer = prevAnswer.filter((i) => i !== item);
            } else {
                updatedAnswer = [...prevAnswer, item];
            }

            updatedAnswer.sort((a, b) => a - b);

            // we will enabled the next button if can proceed
            const canProceed = updatedAnswer.length > 0;

            onAnswer({
                canProceed,
                answer: updatedAnswer,
            });

            return updatedAnswer;
        });
    };

    return (
        <Box
            sx={{
                width: "100%",
                maxWidth: 854,
                height: "auto",
                aspectRatio: "854 / 450",
                margin: "0 auto",
                padding: "20px",
                position: "relative",
                backgroundColor: "white",
                backgroundImage: `url(${imagesResources}${data.image})`,
                backgroundSize: "contain",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
            }}
        >
            {boxes.map((box, index) => (
                <Box className={(answer.includes((index + 1).toString()) ? "selected-img-bg  selected-img-border " : "")}
                    key={box.id}
                    onClick={() => handleBoxClick(index)}
                    sx={{
                        position: "absolute",
                        top: `${box.top}%`,
                        left: `${box.left}%`,
                        width: `${(box.width / 854) * 100}%`,
                        height: `${(box.height / 450) * 100}%`,
                        cursor: "pointer",
                    }}
                />
            ))}
        </Box>
    );
};
